/*
 * @Author: WYX
 * @Date: 2019-12-26
 * @LastEditTime: 2021-12-10 17:55:03
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\resourceCenter\directive\resourceList\resourceVideoUpload\resourceVideoUpload.js
 * @Description: 视频上传模块
 */

angular.module('resourceVideoUploadModule', []).directive('resourceVideoUpload', [
    '$q',
    '$timeout',
    'modalDialog',
    'mrApiService',
    'trsspliceString',
    'trsHttpService',
    'editCenUploadVideoForXjService',
    'mrService',
    '$validation',
    '$sessionStorage',
    'mediaSelectorSevice',
    function ($q, $timeout, modalDialog, mrApiService, trsspliceString, trsHttpService, editCenUploadVideoForXjService, mrService, $validation, $sessionStorage, mediaSelectorSevice) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/directive/resourceList/resourceVideoUpload/resourceVideoUpload.html',
            replace: true,
            transclude: true,
            link: function ($scope) {
                initStatus();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 人物标签
                        personTips: [],
                        // 地点标签
                        placeTips: [],
                        // 事物标签
                        thingTips: [],
                    };
                    $scope.status = {
                        complete: 100, // 上传完成
                        unit: 1024, // 单位
                        burst: 5, // 分片
                        division: 20, // 分片间隔数，超过该数认为是大视频
                        uploadNum: 0,
                        waitTime: $scope.basicalStatus.commonParams.mainResourceType === '0' ? 1000 : 5000,
                        messagePicUrl: `${trsHttpService.getMRURL()}/${$scope.basicalStatus.commonParams.mrType}/0/upload`,
                        imgUploaderOptions: editCenUploadVideoForXjService.singleImageOption,
                        canSaveMaterial: false,
                        picFormdata: {
                            mrEnable: 0,
                            fileId: $scope.basicalStatus.currentFolderId || 0,
                        },
                    };
                    $scope.uploadObj = null;
                    mediaSelectorSevice.initVideoUploader($scope).then((uploader) => {
                        $scope.uploader = uploader;
                        $scope.uploader.registerUrl = '/bigdata/mr/' + $scope.basicalStatus.commonParams.mrType + '/' + $scope.basicalStatus.commonParams.mainResourceType + '/uploadByTempPath'; 
                        if ($scope.basicalStatus.commonParams.mainResourceType === '1' && $scope.uploader.uploaderOptions) {
                            $scope.uploader.uploaderOptions.accept = {
                                title: '音频',
                                extensions: 'mp3,flac,wav,wma',
                                mimeTypes: 'audio/*',
                            };
                        }
                    });
                   
                    // 上传的对象数组
                    $scope.unuploadList = [];
                    $scope.uploadListCache = [];
                    $scope.uploadImages = {
                        success: function (file, src) {
                            for (let i = 0; i < $scope.unuploadList.length; i++) {
                                if ($scope.unuploadList[i].id === file.id) {
                                    $scope.status.uploadNum--;
                                    $scope.unuploadList[i].progress = '100%';
                                    $scope.unuploadList[i].status = '正在处理中...';
                                    $scope.status.canSaveMaterial = true;
                                    $scope.unuploadList[i].relationId = src.datas.relationid;
                                    $scope.unuploadList[i].personTips = src.datas.labelvos;
                                    $scope.setUploadItemCache(i, $scope.unuploadList[i]);
                                    $scope.$apply();
                                    $scope.startInterval($scope.unuploadList[i], i);
                                    break;
                                }
                            }
                        },
                        error: function (file, msg) {
                            modalDialog.alertType('上传失败', msg || '请重新上传', 'error', false);
                            for (let i = 0; i < $scope.unuploadList.length; i++) {
                                if ($scope.unuploadList[i].id === file.id) {
                                    $scope.unuploadList[i].status = '上传失败';
                                    break;
                                }
                            }
                            $scope.deleteList(file);
                        },
                        file: function (file, uploader) { },
                        tar: function (file, percentage) {
                            for (let i = 0; i < $scope.unuploadList.length; i++) {
                                if ($scope.unuploadList[i].id === file.id) {
                                    $scope.unuploadList[i].progress = percentage.toFixed(2) + '%';
                                    $scope.$apply();
                                    break;
                                }
                            }
                        },
                        start: function (file) {
                            let maxTitleLength = 104;
                            if (file.name && file.name.length && file.name.length > maxTitleLength) {
                                modalDialog.alertType('', '上传失败，图片标题过长，请确保图片标题少于100个汉字', 'error', 'confirm', '', '', '', '', '我知道了');
                                return;
                            }
                            let fileName = angular.copy(file.name);
                            // file.selectClass = $scope.basicalData.articleClassArr[0];
                            file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                            if ($scope.isShowPrice()) {
                                file.price = 0;
                            }
                            $scope.unuploadList.push(file);
                            $scope.unuploadList[$scope.unuploadList.length - 1].status = '正在上传中...';
                            $scope.status.canSaveMaterial = false;
                            $scope.unuploadList[$scope.unuploadList.length - 1].progress = '0%';
                            $scope.status.uploadNum++;
                            mrApiService.getExifInfo($scope.unuploadList[$scope.unuploadList.length - 1].source.source, $scope.unuploadList[$scope.unuploadList.length - 1]);
                            $scope.$apply();
                        },
                        comp: function (file) { },
                        finish: function (file) { },
                    };
                }

                /**
                 * [setUploadItemCache 缓存文件信息，避免获取详情后文件对象改变]
                 * @param   {[type]}  index  [index description]
                 * @param   {[type]}  item   [item description]
                 * @return  {[type]}         [return description]
                 */
                $scope.setUploadItemCache = function(index, item) {
                    $scope.uploadListCache[index] = item;
                };

                /**
                 * [isShowPrice 是否显示售价]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.isShowPrice = function () {
                    return $scope.basicalStatus.commonParams.mainResourceType === '0' && $scope.basicalStatus.commonParams.mrType === 'meizi';
                };

                /**
                 * [loadTips description] 加载事物标签或者地点标签
                 * @param   {[type]}  word  [word description]
                 * @param   {[type]}  type  [type description]
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.loadTips = function (word, type, item) {
                    mrService.loadTips($scope, word, type).then(function (data) {
                        if (!data.length && type === 'place' && item.searchPlaceWord !== '') {
                            item.isShowPlaceMarkTip = true;
                        } else if (type === 'place' && (data.length || item.searchPlaceWord === '')) {
                            item.isShowPlaceMarkTip = false;
                        }
                        item[type] = data;
                        item = mrService.addTag(item, data, type, word);
                    });
                };

                // eslint-disable-next-line valid-jsdoc
                /**
                 * [closeDia description]关闭弹窗
                 * @param {[type]} [check 是否勾选]
                 * @return  {[type]}  [return description]
                 */
                $scope.closeDia = function (check) {
                    if (check) {
                        $scope.unuploadList.forEach((item) => {
                            $timeout.cancel(item.fastVideoTimer);
                        });
                        $scope.unuploadList = [];
                        $scope.basicalStatus.showUpload = false;
                        $timeout(() => {
                            $scope.basicalStatus.showUpload = null;
                        });
                    } else {
                        if ($scope.unuploadList.length > 0) {
                            modalDialog.confirmModal(
                                '提示信息',
                                '现在退出将不对素材进行保存，是否确认退出',
                                function () {
                                    var ids = '';
                                    $scope.unuploadList.forEach((item) => {
                                        $timeout.cancel(item.fastVideoTimer);
                                        if (item.relationId) {
                                            ids = ids ? ids + ',' + item.relationId : item.relationId;
                                        }
                                    });
                                    if (ids) {
                                        mrApiService.deleteMaterial(angular.extend({ relationIds: ids }, $scope.basicalStatus.commonParams));
                                    }
                                    $scope.unuploadList = [];
                                    $scope.status.uploadNum = 0;
                                    $scope.basicalStatus.showUpload = false;
                                    $timeout(() => {
                                        $scope.basicalStatus.showUpload = null;
                                    });
                                },
                                () => {
                                    return;
                                }
                            );
                        } else {
                            $scope.basicalStatus.showUpload = false;
                            $timeout(() => {
                                $scope.basicalStatus.showUpload = null;
                            });
                        }
                    }
                };

                /**
                 * [uploadTest description]视频上传
                 * @return {[type]} [description]
                 */
                $scope.upload = function () {
                    mediaSelectorSevice.doUploader();
                };

                /**
                 * [startInterval description] 设置定时器
                 * @param   {[type]}  item  [item description]
                 * @param   {[type]}  index  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.startInterval = function(item, index) {
                    $timeout.cancel(item.fastVideoTimer);
                    $scope.status.canSaveMaterial = true;
                    beginTimeout(item, index);
                };

                /**
                 * [beginTimeout description] 开始计时
                 * @param   {[type]}  item  [item description]
                 * @param   {[type]}  index  [item description]
                 * @return  {[type]}        [return description]
                 */
                function beginTimeout(item, index) {
                    item.fastVideoTimer = $timeout(function () {
                        getVideoInfo(item, index).then(function () {
                            beginTimeout(item, index);
                        });
                    }, $scope.status.waitTime);
                }

                /**
                 * [getVideoInfo description] 获得视频详情
                 * @param   {[type]}  item  [item description]
                 * @param   {[type]}  index  [item description]
                 * @return  {[type]}        [return description]
                 */
                function getVideoInfo(item, index) {
                    var deffer = $q.defer();
                    let mediaFormatFailCode = -10;
                    let mediaCheckFailCode = -1;
                    let mediaFormatingCode = 10;
                    let relationId = item.relationid || item.relationId;
                    if (relationId) {
                        mrApiService.getMaterialDetail(angular.extend({ relationId: relationId }, $scope.basicalStatus.commonParams)).then(
                            function (data) {
                                if (data.datas[0] && data.datas[0].resourcestatus !== mediaFormatingCode) {
                                    if (data.datas[0].resourcestatus === mediaFormatFailCode) {
                                        item.URL = data.datas[0].previewurl;
                                        item.status = '转码失败';
                                        $scope.status.canSaveMaterial = false;
                                    } else {
                                        item.URL = data.datas[0].previewurl;
                                        item.resourcestatus = data.datas[0].resourcestatus;
                                        item.resourceid = data.datas[0].resourceid;
                                        item.status = '转码完成';
                                        $scope.status.canSaveMaterial = true;
                                        if (data.datas[0].resourcestatus === mediaCheckFailCode) {
                                            // $scope.status.canSaveMaterial = false;
                                            item.isShowAuditingStatus = false;
                                            item.audidingErrors = [];
                                        }
                                        if ($scope.isShowPrice()) {
                                            $scope.unuploadList[index].price = $scope.uploadListCache[index].price;
                                        }
                                    }
                                    deffer.reject();
                                } else {
                                    if ($scope.isShowPrice()) {
                                        $scope.unuploadList[index].price = $scope.uploadListCache[index].price;
                                    }
                                    deffer.resolve();
                                }
                            },
                            function () {
                                deffer.resolve();
                                modalDialog.alertType('查询信息失败', '重新查询', 'warning', false);
                            }
                        );
                    } else {
                        deffer.reject();
                    }

                    return deffer.promise;
                }

                /**
                 * [deleteList description] 视频删除
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.deleteList = function (item) {
                    if (item.status === '正在上传中...') {
                        modalDialog.alertType('请等待上传完成后在删除！', '', 'info');
                        return;
                    }
                    var i = $scope.unuploadList.indexOf(item);
                    if ($scope.unuploadList[i].relationId) {
                        $timeout.cancel($scope.unuploadList[i].fastVideoTimer);
                        mrApiService.deleteMaterial(
                            angular.extend({ relationIds: $scope.unuploadList[i].relationId }, $scope.basicalStatus.commonParams)
                        );
                    } else {
                        $scope.status.uploadNum--;
                    }
                    if ($scope.uploadObj && $scope.basicalStatus.commonParams.mainResourceType !== '0') {
                        $scope.uploadObj.removeFile($scope.unuploadList[i]);
                    }
                    $scope.unuploadList.splice(i, 1);
                    $scope.uploadListCache.splice(i, 1);
                };

                /**
                 * [saveMessage description] 保存
                 * @return  {[type]}  [return description]
                 */
                $scope.saveMessage = function () {
                    if ($scope.status.uploadNum !== 0) {
                        modalDialog.alertType('', '素材仍在上传中请稍候', 'warning', false);
                        return;
                    }
                    if ($scope.unuploadList.length === 0) {
                        modalDialog.alertType('', '您还没有上传素材文件', 'warning', false);
                        return;
                    }
                    $scope.uploadForm.$pending = {};
                    $validation.validate($scope.uploadForm).success(function () {
                        $scope.loadingPromise = updateMaterial().then(
                            () => {
                                modalDialog.alertType('保存成功', '', 'success', false);
                                $scope.requestData();
                                $scope.closeDia(true);
                            },
                            () => {
                                modalDialog.alertType('保存失败', '请重试', 'warning', false);
                            }
                        );
                    });
                };

                /**
                 * [updateMaterial description] 调用保存（更新）接口
                 * @return  {[type]}  [return description]
                 */
                function updateMaterial() {
                    var deffer = $q.defer();
                    var check = true;
                    var index = 0;
                    $scope.unuploadList.forEach((item) => {
                        var eventmark = '';
                        var personmark = '';
                        var placemark = '';
                        if ($scope.basicalStatus.commonParams.mainResourceType !== '0') {
                            eventmark = trsspliceString.spliceString(angular.copy(item.eventmark), 'name', ';');
                            personmark = trsspliceString.spliceString(angular.copy(item.personmark), 'name', ';');
                            placemark = trsspliceString.spliceString(angular.copy(item.placemark), 'name', ';');
                        } else {
                            if (item.selectedEventTips && item.selectedEventTips.length) {
                                for (var j = 0; j < item.selectedEventTips.length; j++) {
                                    if (item.selectedEventTips[j].id === '0' && !item.selectedEventTips[j].imageurl) {
                                        item.selectedEventTips[j].imageurl = item.URL;
                                    }
                                }
                                eventmark = JSON.stringify(item.selectedEventTips);
                            }
                            if (item.selectedPlaceTips && item.selectedPlaceTips.length) {
                                placemark = JSON.stringify(item.selectedPlaceTips);
                            }
                            if (item.personTips && item.personTips.length) {
                                personmark = JSON.stringify(item.personTips);
                            }
                        }
                        var params = {
                            relationId: item.relationId,
                            resourceTitle: item.fileName,
                            eventmark: eventmark,
                            personmark: personmark,
                            placemark: placemark,
                            fileId: $scope.basicalStatus.currentFolderId || 0,
                            mrEnable: 1,
                            author: item.author,
                            filmingEvent: item.filmingevent,
                            filmingLocation: item.filminglocation,
                            filmingTime: item.filmingtime,
                            content: item.content
                        };
                        if ($scope.isShowPrice()) {
                            params.price = item.price || 0;
                        }
                        mrApiService.updateMaterial(angular.extend(params, $scope.basicalStatus.commonParams)).then((response) => {
                            index++;
                            if (response.code !== '200') {
                                check = false;
                            }
                            if (index >= $scope.unuploadList.length) {
                                if (check) {
                                    deffer.resolve();
                                } else {
                                    deffer.reject();
                                }
                            }
                        });
                    });
                    return deffer.promise;
                }

                /**
                 * [initAuddingStatus 初始化审核不通过的原因]
                 * @param   {[type]}  item  [item 未通过审核的素材]
                 * @return  {[type]}        [return description]
                 */
                function initAuddingStatus(item) {
                    if (item.resourcestatus && item.resourcestatus === -1) {
                        if (item.audidingErrors && item.length > 0) {
                            item.isShowAuditingStatus = true;
                        } else {
                            let param = {
                                resourceid: item.resourceid ? item.resourceid : 0,
                                tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                                userName: $sessionStorage.get('curUserInfo').USERNAME,
                            };
                            mrApiService.getErrorMsg(param).then(function (data) {
                                if (data.code === '200') {
                                    item.audidingErrors = data.datas;
                                    item.isShowAuditingStatus = true;
                                }
                            });
                        }
                    }
                }

                $scope.showAuditing = function (item) {
                    initAuddingStatus(item);
                };

                /**
                 * [isShowLabelTips 是否显示事物标签错误提示]
                 *
                 * @param   {[type]}  item  [type description]
                 * @param   {[type]}  type  [type description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.isShowLabelTips = function (item, type) {
                    return $scope.uploadForm.$error.leftoverText && type === 'event' && item.searchEventWord && item.searchEventWord !== '';
                };
            },
        };
    },
]);
